import { getAppConfig } from '@services/config';
import { apiHttpService } from '@services/http';
import { CACHE_TAGS } from '@services/http/http';
import { logger } from '@services/loggers';

import { McoOptionType } from '@app-types/cms';

const appConf = getAppConfig();

export const getMcoModal = async (): Promise<McoOptionType[] | undefined> => {
    return apiHttpService
        .get<{ items: McoOptionType[] }>(`${appConf.assets.cms.url}/statics/mCommerceAPI/mco_option`, undefined, {
            ttl: parseInt(getAppConfig().cache.ttl.products),
            tags: [CACHE_TAGS.PRODUCTS],
        })
        .then((res) => {
            return res.items;
        })
        .catch((error) => {
            logger.log('path:', `${appConf.assets.cms.url}/statics/mCommerceAPI/mco_option`);
            logger.error('[error mco_option]: ', error);
            return [];
        });
};
